/** The Wrapped task's data: reads the board's state and sends its three actions. */

import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { buildWrapped, putWrappedSettings, releaseWrapped, removeMusic, uploadMusic, useWrappedAdmin } from "../../wrapped/api";
import { Notice, Section } from "../shared";
import { WrappedTaskView } from "./WrappedTaskView";

export function WrappedTask() {
  const queryClient = useQueryClient();
  const admin = useWrappedAdmin();
  const [error, setError] = useState<string | null>(null);

  const run = (action: () => Promise<unknown>) =>
    action().then(
      () => {
        setError(null);
        void queryClient.invalidateQueries({ queryKey: ["wrapped-admin"] });
        void queryClient.invalidateQueries({ queryKey: ["wrapped-available"] });
      },
      (failure: Error) => setError(failure.message),
    );

  if (!admin.data) {
    return (
      <Section id="wrapped" title="Wrapped">
        {admin.error ? <Notice tone="error">{admin.error.message}</Notice> : <Notice>Loading…</Notice>}
      </Section>
    );
  }
  return (
    <WrappedTaskView
      data={admin.data}
      error={error}
      onSave={(end, title) => run(() => putWrappedSettings({ end, title }))}
      onBuild={() => run(buildWrapped)}
      onRelease={(released) => run(() => releaseWrapped(released))}
      onUploadMusic={(file) => run(() => uploadMusic(file))}
      onRemoveMusic={() => run(removeMusic)}
    />
  );
}
